/**
 * Created by david.vanoni@coplex.com on 8/28/17.
 */

import { CALL_API, HTTP_METHODS } from '../middlewares/api.js';

// API Actions
const SEND_SURVEY_REQUEST = 'changesync/surveys/SEND_SURVEY_REQUEST';
const SEND_SURVEY_SUCCESS = 'changesync/surveys/SEND_SURVEY_SUCCESS';
const SEND_SURVEY_FAILURE = 'changesync/surveys/SEND_SURVEY_FAILURE';

// Initial State
const initialState = {
  sendSurvey: { pending: false },
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case SEND_SURVEY_REQUEST:
      return {
        ...state,
        sendSurvey: {
          ...state.sendSurvey,
          pending: true,
        },
      };

    case SEND_SURVEY_SUCCESS:
      return {
        ...state,
        sendSurvey: {
          ...state.sendSurvey,
          pending: false,
        },
      };

    case SEND_SURVEY_FAILURE:
      return {
        ...state,
        sendSurvey: {
          ...state.sendSurvey,
          pending: false,
        },
      };

    default:
      return state;
  }
};

// Action Creators

export const sendSurvey = (id) => ({
  [CALL_API]: {
    types: [SEND_SURVEY_REQUEST, SEND_SURVEY_SUCCESS, SEND_SURVEY_FAILURE],
    endpoint: `surveys/${id}/send`,
    method: HTTP_METHODS.POST,
  },
});

// Selectors

export const selectSendSurveyState = () => (state) => state.surveys.sendSurvey;
